import React from 'react';
export const Logo = ({
  className = ''
}) => {
  return <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9Cw1b8zLBpZxxMcrgHNCwN/LogoPraiseKaraoke_-_Edited.png" alt="Praise Karaoke" className={`h-16 ${className}`} data-id="element-84" />;
};